import script from "./AbsenceType.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceType.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceType.vue?vue&type=style&index=0&id=628b926b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628b926b"]])

export default __exports__